import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';


export default function AlertDialog({alertOptions}) {
  
    const {isOpen, activePlayers, onCancel, onConfirm, isLoading} =  alertOptions

    const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  const titleTxt = `Are you sure?`
  const confirmMsg = `This will reset the server and kick the ${activePlayers || ''} players.`

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        onBackdropClick={onCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{titleTxt}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {confirmMsg}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel} color="secondary">
            Cancel
          </Button>
          {isLoading ? <CircularProgress/> : 
          <Button onClick={onConfirm} color="secondary" autoFocus>
            Confirm
          </Button>
}
        </DialogActions>
      </Dialog>
    </div>
  );
}
